















































































import { Component, Vue } from 'vue-property-decorator';
import GalaHonor from '~/components/GalaHonor/GalaHonor.vue';
import GalaHonorActions from '~/components/GalaHonor/Actions.vue';
import { Action, State } from 'vuex-class';
import { IGalaHonor } from '~/store/profile/types';
import getDistributionResultsSummary from '~/queries/distributionResultsSummary.gql';

@Component({
  components: { GalaHonor, GalaHonorActions },
})
export default class GalaHonorOverview extends Vue {
  @Action('fetchGalaHonor', { namespace: 'profile' })
  private fetchGalaHonor!: () => void;
  @State(profile => profile.user.galaHonor, { namespace: 'profile' })
  readonly galaHonor!: IGalaHonor;

  distributionResults: number = 0;

  async fetchDistributionResults(token: string) {
    const date = new Date().setDate(new Date().getDate() - 1);
    try {
      const variables = date
        ? { date, tokenType: token }
        : { tokenType: token };
      const response = await this.$apollo.query({
        query: getDistributionResultsSummary,
        variables,
        fetchPolicy: 'no-cache',
      });

      const { distributionPersonalResultsSummary } = response.data;

      this.distributionResults = distributionPersonalResultsSummary.coinTokens;
    } catch (error) {
      this.$sentry.captureException(error);
      const errorMessage = date
        ? (this.$t('pages.nodes.myNode.unableToGetResultsFor', {
            date: new Date(date).toLocaleDateString(),
          }) as string)
        : (this.$t('pages.nodes.myNode.unableToGetResults') as string);
      console.log(errorMessage);
    }
  }

  mounted() {
    this.fetchGalaHonor();
    this.fetchDistributionResults('SILK');
  }
}
